import { Component, OnInit } from '@angular/core';
import { RequestCustomfieldService } from 'src/app/page_component/request-customfield/service/request-customfield.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { RegisterRequestCustomfieldService } from './service/request-customfield.service';
import { classificationInterface } from 'src/app/util/interfaces/classification';
import { requestClassificationInterface } from 'src/app/util/interfaces/requestClassification';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { forkJoin } from 'rxjs';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { faAngleDown, faAngleUp, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { taskManagementInterface, TaskManagementService } from '../task-management/service/task-management.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'register-form-request-customfield',
	templateUrl: './request-customfield.component.html',
	styleUrl: './request-customfield.component.scss',
})
export class RegisterRequestCustomfieldComponent implements OnInit {
	icons = {
		faAngleDown: faAngleDown,
		faAngleUp: faAngleUp,
		faTimes: faTimes,
		faTrash: faTrash,
	};

	labels: LabelsInterface = {
		lbl_geral_sim: '',
		lbl_geral_nao: '',
		lbl_geral_campos_customizados: '',
		lbl_geral_nome: '',
		lbl_tipo_do_campo: '',
		lbl_geral_mandatory: '',
		lbl_visivel_apenas_para_analistas: '',
		lbl_status_desativado: '',
		lbl_geral_excluir: '',
		lbl_geral_adicionar: '',
		lbl_geral_salvar: '',
		lbl_geral_texto: '',
		lbl_geral_selecao: '',
		lbl_geral_anexo: '',
		lbl_sim_ou_nao: '',
		lbl_itens_da_selecao: '',
		lbl_salvo_com_sucesso: '',
		lbl_geral_ocultar: '',
		lbl_geral_novo: '',
		lbl_geral_subcampos: '',
		lbl_subcampo_invalido_na_linha: '',
		lbl_clique_confirmar_acao: '',
		lbl_geral_buscar: '',
		lbl_geral_voltar: '',
		lbl_classificacoes_salvas: '',
		lbl_vincule_pelo_menos_uma_classificacao_para_continuar: '',
		lbl_campos_customizados_aparecerao_determinadas_classificacoes: '',
		lbl_para_buscar_por_classificacao_preencha_toda_classificacao: '',
		lbl_geral_preencha_classificacao: '',
		lbl_geral_selecao_multipla: '',
		lbl_geral_selecao_aprovadores: '',
		lbl_chamado_tarefa: '',
		lbl_geral_selecione: '',
		lbl_geral_vincule_tarefa_continuar: '',
		lbl_geral_classificacao_sem_tarefa_relacionada: '',
		lbl_geral_caixa_texto: 'Textarea',
	};

	classificationOptions = {
		isEditingClassification: true,
		alertField: [],
		selectedCustomer: this.ProfileService.userData().idCustomer,
		hideServiceType: [],
		hideField: ['impact', 'urgency', 'severity'],
		idCmdb: '',
		requiredField: [],
	};

	selectItems: genericFormInterface[] = [
		{
			name: 'selectItems',
			label: 'lbl_itens_da_selecao',
			inputType: 'multi-input',
			values: [],
			outItems: [],
			items: [
				{
					name: 'name',
					label: 'lbl_geral_nome',
					inputType: 'string',
					required: true,
					values: [''],
				},
				{
					name: 'subtype',
					label: 'lbl_geral_subcampos',
					inputType: 'multi-select',
					values: [],
					outItems: [],
					items: [],
					filterItem: [''],
					filterValues: [''],
					rawValues: [''],
				},
			],
			filterItem: [''],
			filterValues: [''],
			rawValues: [''],
			multiInputLineId: [],
			allowEdit: true,
		},
	];

	requestViewItems: mspTableHeaderI[] = [
		{
			name: 'name',
			value: 'lbl_geral_nome',
			colType: 'text',
		},
	];

	constructor(
		private ProfileService: ProfileService,
		private LabelsService: LabelsService,
		private RegisterRequestCustomfieldService: RegisterRequestCustomfieldService,
		private NotificationService: NotificationService,
		private taskManagementService: TaskManagementService
	) {}

	isLoadingLabels = true;
	isLoadingCustomfields = false;
	isLoadingBounceCustomFields = false;

	isUpdatingCustomfield = false;
	isLoadingTasks = false;

	searchName = '';
	searchClassification: classificationInterface = {
		serviceType: [],
		scope: [],
		category: [],
		topic: [],
		solutionArea: [],
	};
	selectedCustomfield: genericFormInterface = undefined;
	selectedCustomfieldClassification: classificationInterface[] = [];
	selectedClassification: classificationInterface = {
		serviceType: [],
		scope: [],
		category: [],
		topic: [],
		solutionArea: [],
	};
	selectedTask = '';
	customfieldArrMemory: genericFormInterface[] = [];
	customfieldArr: genericFormInterface[] = [];
	selectedIndex: number;

	tasks: taskManagementInterface[] = [];

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe({
			next: (labels) => {
				this.labels = labels;
			},
			complete: () => {
				this.isLoadingLabels = false;
			},
		});

		this.getCustomfields('', '', '', true);
	}

	setClassification(classification: string, classificationVariable: 'searchClassification' | 'selectedClassification'): void {
		const requestClassification: classificationInterface = JSON.parse(classification);
		this[classificationVariable].serviceType = requestClassification.serviceType ? requestClassification.serviceType : [];
		this[classificationVariable].scope = requestClassification.scope ? requestClassification.scope : [];
		this[classificationVariable].category = requestClassification.category ? requestClassification.category : [];
		this[classificationVariable].topic = requestClassification.topic ? requestClassification.topic : [];
		this[classificationVariable].solutionArea = requestClassification.solutionArea ? requestClassification.solutionArea : [];
	}

	searchCustomfields(): void {
		if (this.searchClassification.serviceType.length > 0 && this.searchClassification.solutionArea.length === 0) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_para_buscar_por_classificacao_preencha_toda_classificacao);
			return;
		}

		if (this.isLoadingBounceCustomFields) return;

		this.getCustomfields(
			this.searchName,
			this.searchClassification.category[0] ? this.searchClassification.category[0].id : '',
			this.searchClassification.topic[0] ? this.searchClassification.topic[0].id : '',
			false
		);
	}

	getCustomfields(name: string, idCategory: string, idTopic: string, newer: boolean): void {
		this.isLoadingBounceCustomFields = true;
		this.RegisterRequestCustomfieldService.getCustomfields(name, idCategory, idTopic, newer).subscribe({
			next: (customfield) => {
				customfield = customfield.map((cf) => {
					if (
						cf.inputType == 'Select' ||
						cf.inputType == 'Multi-Select' ||
						cf.inputType == 'Radio' ||
						cf.inputType == 'Checkbox'
					) {
						const itemId: string[] = [];
						const itemName: string[][] = [];
						for (const item of cf.items) {
							itemId.push(item.id);
							const temporary = [];
							temporary.push(item.name);
							if (cf.inputType == 'Select') temporary.push(item.subfield_items);
							itemName.push(temporary);
						}
						const copySelectItems: genericFormInterface[] = JSON.parse(JSON.stringify(this.selectItems));
						if (cf.inputType == 'Multi-Select' || cf.inputType == 'Radio' || cf.inputType == 'Checkbox') {
							copySelectItems[0].items.splice(1, 1);
						}
						copySelectItems[0].values = itemName;
						copySelectItems[0].multiInputLineId = itemId;
						cf.items = copySelectItems;
					}
					return cf;
				});
				this.customfieldArr = JSON.parse(JSON.stringify(customfield));
				this.customfieldArrMemory = JSON.parse(JSON.stringify(this.customfieldArr));
			},
			complete: () => {
				this.isLoadingCustomfields = false;
				this.isLoadingBounceCustomFields = false;
			},
		});
	}

	selectCustomfield(customfield: genericFormInterface[]): void {
		this.isLoadingCustomfields = true;
		this.selectedCustomfield = customfield[0];
		this.selectedTask = customfield[0].relatedTask;

		this.RegisterRequestCustomfieldService.getCustomfieldClassification(this.selectedCustomfield.id).subscribe({
			next: (classification) => {
				this.selectedCustomfieldClassification = classification;
				if (this.selectedCustomfield.inputType == 'Select-Approver') {
					this.getGroupTasks(true);
				}
			},
		});
		if (this.selectedCustomfield.inputType == 'Select') {
			this.selectedCustomfield.items[0].items[1].items = [];
			this.RegisterRequestCustomfieldService.getCustomfieldSubfield(this.selectedCustomfield.id).subscribe({
				next: (subfield) => {
					const newItemArray: genericFormInterface[] = [];
					for (const sf of subfield) {
						const newItem: genericFormInterface = {
							id: sf.id.toString(),
							name: sf.name,
							label: sf.name,
							values: [sf.id.toString()],
							value: sf.id.toString(),
						};
						newItemArray.push(newItem);
					}

					this.selectedCustomfield.items[0].items[1].items = newItemArray;
				},
				complete: () => {
					this.isLoadingCustomfields = false;
				},
			});
		}
	}

	addNewCustomfield(): void {
		this.selectedCustomfield = {
			id: '-1',
			name: 'Novo campo customizado',
			label: 'Novo campo customizado',
			inputType: 'Text',
			required: false,
			disabled: false,
			hidden: false,
			analystView: false,
			items: [],
			multiInputLineId: [],
		};
		this.selectedCustomfieldClassification = [];
	}

	addClassification(): void {
		if (this.selectedClassification.solutionArea.length === 0) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_geral_preencha_classificacao);
			return;
		}
		this.selectedCustomfieldClassification.push(this.selectedClassification);
		if (this.selectedCustomfield.inputType == 'Select-Approver') {
			this.getGroupTasks();
		}
	}

	createCustomfield(): void {
		if (this.selectedCustomfieldClassification.length === 0) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_vincule_pelo_menos_uma_classificacao_para_continuar);
			return;
		}

		if (this.isUpdatingCustomfield) return;

		if (this.selectedCustomfield.inputType === 'Select-Approver' && this.selectedTask === '')
			return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_vincule_tarefa_continuar);

		this.isUpdatingCustomfield = true;
		this.RegisterRequestCustomfieldService.createCustomfield(
			this.selectedCustomfield,
			this.selectedCustomfieldClassification,
			this.selectedTask
		).subscribe({
			next: (customfieldRes) => {
				this.selectedCustomfield.id = customfieldRes[0];
				this.NotificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
			},
			complete: () => {
				this.isUpdatingCustomfield = false;
			},
		});
	}

	updateCustomfield(): void {
		if (this.selectedCustomfieldClassification.length === 0) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_vincule_pelo_menos_uma_classificacao_para_continuar);
			return;
		}

		if (this.isUpdatingCustomfield) return;

		if (this.selectedCustomfield.inputType === 'Select-Approver' && this.selectedTask === '')
			return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_vincule_tarefa_continuar);

		this.isUpdatingCustomfield = true;
		this.RegisterRequestCustomfieldService.updateCustomfield(
			this.selectedCustomfield,
			this.selectedCustomfieldClassification,
			this.selectedTask
		).subscribe({
			next: (res) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
			},
			complete: () => {
				this.isUpdatingCustomfield = false;
			},
		});
	}

	deleteCustomfield(): void {
		this.RegisterRequestCustomfieldService.deleteCustomfield(this.selectedCustomfield.id).subscribe({
			complete: () => {
				this.customfieldArr.splice(this.selectedIndex, 1);
				this.customfieldArrMemory.splice(this.selectedIndex, 1);
				this.NotificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
				this.selectedCustomfield = undefined;
				this.selectedIndex = undefined;
			},
		});
	}

	validateSubfield(): boolean {
		const allowedCustomfieldId = new Set(
			this.customfieldArr.map((cf) => {
				return cf.id.toString();
			})
		);
		let isSubfieldValid = true;
		for (let index = 0; index < this.customfieldArr.length; index++) {
			const cf = this.customfieldArr[index];
			if (cf.inputType != 'Select') continue;

			for (const [index, value] of cf.items[0].values.entries()) {
				const subfieldIdArray = value[1].split(',');
				if (subfieldIdArray[0] != '') {
					const validSubfield = [];
					subfieldIdArray.some((r) => {
						validSubfield.push(allowedCustomfieldId.has(r.toString()));
					});

					if (validSubfield.includes(false)) {
						cf.items[0].alertIndex = index;
						this.NotificationService.setNotificationMessage(
							this.labels.lbl_subcampo_invalido_na_linha.replace('{{line}}', index)
						);
						isSubfieldValid = false;
					}
				}
			}
		}
		return isSubfieldValid;
	}

	changeFieldType(customfield: genericFormInterface, fieldType: string): void {
		customfield.inputType = '';
		setTimeout(() => {
			customfield.inputType = fieldType;
			if (fieldType == 'Select') {
				customfield.items = JSON.parse(JSON.stringify(this.selectItems));
				customfield.values = [];
				customfield.outItems = [];
			} else if (fieldType == 'Select-Approver') {
				this.getGroupTasks();
			} else if (fieldType == 'Multi-Select' || fieldType == 'Radio' || fieldType == 'Checkbox') {
				customfield.items = JSON.parse(JSON.stringify(this.selectItems));
				customfield.items[0].items.splice(1, 1);
				customfield.values = [];
				customfield.outItems = [];
			} else customfield.items = [];
		}, 10);
	}

	confirmButton(elementReference: HTMLElement): void {
		this.NotificationService.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
		elementReference.classList.add('confirmClick');
		setTimeout(() => {
			elementReference.classList.remove('confirmClick');
		}, 5000);
	}

	getGroupTasks(isUpdating?: boolean): void {
		this.tasks = [];

		if (!isUpdating) {
			this.selectedTask = '';
		}

		if (
			this.selectedCustomfieldClassification.length > 0 &&
			(this.selectedCustomfieldClassification[0].solutionArea[0].name != '' ||
				this.selectedCustomfieldClassification[0].scope[0].name != '' ||
				this.selectedCustomfieldClassification[0].category[0].name != '' ||
				this.selectedCustomfieldClassification[0].topic[0].name != '' ||
				this.selectedCustomfieldClassification[0].serviceType[0].name != '')
		) {
			this.isLoadingTasks = true;

			this.taskManagementService
				.getGroupTasks({
					solutionArea: this.selectedCustomfieldClassification[0].solutionArea[0].name,
					scope: this.selectedCustomfieldClassification[0].scope[0].name,
					category: this.selectedCustomfieldClassification[0].category[0].name,
					topic: this.selectedCustomfieldClassification[0].topic[0].name,
					serviceType: this.selectedCustomfieldClassification[0].serviceType[0].name,
				})
				.subscribe((data) => {
					this.tasks = data.filter((task) => task.type == 'Authorization' || task.type == 'Review');
					this.isLoadingTasks = false;
				});
		}
		isUpdating = false;
	}

	deleteClassification(index: number) {
		this.selectedCustomfieldClassification.splice(index, 1);
		this.tasks = [];
	}
}
